import { render, staticRenderFns } from "./OwnersListTable.vue?vue&type=template&id=7b681577&scoped=true"
import script from "./OwnersListTable.vue?vue&type=script&lang=js"
export * from "./OwnersListTable.vue?vue&type=script&lang=js"
import style0 from "./OwnersListTable.vue?vue&type=style&index=0&id=7b681577&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b681577",
  null
  
)

export default component.exports